import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { SearchResultsComponent } from 'shared/search/search-results/search-results.component';


@Component({
  moduleId: module.id,
  selector: 'reports-search-results',
  templateUrl: 'reports-search-results.component.html',
  styleUrls: ['reports-search-results.component.scss']
})
export class ReportsSearchResultsComponent extends SearchResultsComponent {
}
